import styled, { css } from "styled-components"
import { motion } from "framer-motion"

export const Wrapper = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: #262424;
  padding-top: 60px;
  z-index: 100;
  & > ul {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  padding-bottom: 35px;
`
export const Chapter = styled.li`
  flex: 1;
  position: relative;
  transition: all 0.3s;
  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #f2efe4;
    text-decoration: none;
  }

  ${props =>
    props.isActive &&
    css`
      background: #4d4033;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: #bf996a;
      }
    `}
`
